import HttpData from "@/http/data/http-data";
import dayjs, { Dayjs } from "dayjs";

export interface IUnitIssueData {
    id: number;
    unit_id: string;
    description: string;
    created_by?: string;
    created_at?: string;
}

export default class UnitIssueData extends HttpData {
    public id: number;
    public unitId: string;
    public description: string;
    public createdBy: null|string;
    public createdAt: null|Dayjs;


    constructor(data: IUnitIssueData) {
        super();

        this.id = data.id;
        this.unitId = data.unit_id;
        this.description = data.description;
        this.createdBy = data.created_by ?? null;
        this.createdAt = data.created_at ? dayjs(data.created_at) : null;
    }

    public get formattedCreatedAt(): string {
        if (!this.createdAt) return "";
        return this.createdAt.format("DD/MM/YYYY HH:mm");
    }
}